import React, { useState } from 'react';
import Title from '../title-tile/titleTileComponent';

const DeliveryDetails = (props) => {
  const [error, setError] = useState(null);
  const [disabledInput, setDisabledInput] = useState(true);

  const ADDRESS_OPTIONS = [
    'Registrado',
    'Retira en Centro de Distribucion',
    'Envio Otro Domicilio',
  ];

  const generateOptions = () => {
    const options = [];
    for (let i = 0; i < ADDRESS_OPTIONS.length; i++) {
      options.push(
        <button
          onClick={handleSelectedAddressType}
          className="dropdown-item"
          key={`key-${ADDRESS_OPTIONS[i]}`}
        >
          {ADDRESS_OPTIONS[i]}
        </button>
      );
    }
    return options;
  };

  const setAddress = (e) => {
    const address = e.target.value;
    if (address) {
      props.setDeliveryTo(address);
      setError(null);
      props.setHasErrors({ address: false });
    } else {
      setError('La direccion no puede estar vacia.');
      props.setHasErrors({ address: true });
    }
  };

  const handleSelectedAddressType = (e) => {
    const value = e.target.textContent;
    setError(null);
    props.setHasErrors({ address: false });

    // Case other address - clean input and enabled
    if (value === ADDRESS_OPTIONS[2]) {
      props.setDeliveryTo('');
      setDisabledInput(false);
    }

    // Case registered - user data and disabled
    if (value === ADDRESS_OPTIONS[0]) {
      props.setDeliveryTo(props.user.address);
      setDisabledInput(true);
    }

    // Case retires from business - show string
    if (value === ADDRESS_OPTIONS[1]) {
      props.setDeliveryTo(value);
      setDisabledInput(true);
    }
  };

  const handleOverrideEnabled = (e) => {
    const enabled = e.target.checked;
    props.setCustomerOverride({
      enabled,
      value: enabled ? props.customerOverride.value : '',
    });

    if (!enabled) {
      props.setHasErrors({ customerOverride: false });
    } else {
      const validValue = /^\d+$/.test(String(props.customerOverride.value || '').trim());
      props.setHasErrors({ customerOverride: !validValue });
    }
  };

  const handleOverrideValue = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    props.setCustomerOverride({ enabled: true, value });
    props.setHasErrors({ customerOverride: value.length === 0 });
  };

  return (
    <div className="order-details-section">
      <Title hide={false} message="Detalle de Envio (Domicilio)" alignLeft={true} />
      <div className="order-details-form-group">
        <div className="order-details-dropdown-wrapper">
          <div className="dropdown show">
            <button
              className="btn btn-dark dropdown-toggle"
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Domicilio de Entrega
            </button>

            <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
              {generateOptions()}
            </div>
          </div>
        </div>
        <div className="order-details-input-wrapper">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                Domicilio:
              </span>
            </div>
            <input
              disabled={disabledInput}
              type="text"
              className="form-control"
              onChange={setAddress}
              value={props.deliverToValue}
              onBlur={setAddress}
            />
          </div>
        </div>
      </div>
      {error && <p className="details-error">{error}</p>}

      {props.canUseCustomerOverride && (
        <div className="order-details-override-wrapper">
          <div className="input-group">
            <div className="input-group-prepend">
              <div className="input-group-text">
                <input
                  type="checkbox"
                  checked={props.customerOverride.enabled}
                  onChange={handleOverrideEnabled}
                  aria-label="Habilitar customer override"
                />
                <span className="customer-override-label">
                  Usar numero de cliente (solo vendedores):
                </span>
              </div>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Numero de cliente"
              inputMode="numeric"
              value={props.customerOverride.value}
              onChange={handleOverrideValue}
              disabled={!props.customerOverride.enabled}
            />
          </div>
          {props.customerOverride.enabled && !props.customerOverride.value && (
            <p className="details-error">Debe ingresar un numero de cliente.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default DeliveryDetails;
